import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ThemeService } from '../../base/services/theme.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AsyncPipe]
})
export class HomeComponent {
  public readonly logoUrl$ = combineLatest([this.themeService.logoUrl$, this.themeService.mode$]).pipe(
    map(([logoUrl, mode]) => logoUrl || this.themeService.getDefaultLogoUrl(mode))
  );

  constructor(private readonly themeService: ThemeService) {
  }
}
